import $ from 'jquery';
import { setHeight } from '../lib/utils/elemsHeight';

const modalProgram = () => {

    const $modalPrint = $('.modal-print');
    const $openModalPrint = $('.btn-modal-program');
    const OPEN_MODAL_TIMEOUT = 350;
    const channelItem = '.tv-program-print__channel';
    const sliderActive = '.tv-program-print__slider-item.active';
    const channelItemHeader = '.tv-program-print__channel-header';

    function setElementsHeight(elemChannelItem) {
        const $headings = $(elemChannelItem).closest(sliderActive).find(channelItemHeader);
        setHeight($headings);
    }

    $modalPrint.each(() => {
        $modalPrint.wrap('<div class="overlay-print"></div>');
    });

    $openModalPrint.on('click', (e) => {
        e.preventDefault();
        const $this = $openModalPrint;
        const modal = $($this).data('modal');


        $(modal).parents('.overlay-print').addClass('open');
        setTimeout(() => {
            $(modal).addClass('open');
            $('body').addClass('ov-hidden');
            setElementsHeight(channelItem);
        }, OPEN_MODAL_TIMEOUT);
    });

    $(document).on('click', (e) => {
        const target = $(e.target);

        if ($(target).hasClass('overlay-print')) {
            $(target).find('.modal-print').each(() => {
                $(this).removeClass('open');
                $('body').removeClass('ov-hidden');
            });
            setTimeout(() => {
                $(target).removeClass('open');
                $('body').removeClass('ov-hidden');
            }, OPEN_MODAL_TIMEOUT);
        }
    });

    $('.tv-program-print__close').on('click', (e) => {
        e.preventDefault();
        $('.overlay-print').removeClass('open');
        $('.modal-print').removeClass('open');
        $('body').removeClass('ov-hidden');
    });
};

export default modalProgram;
